import { extendDataItem, mapTree } from '@progress/kendo-react-common';
import { filterBy } from '@progress/kendo-react-data-tools';

export const processTreeData = (data: any[], state: any, fields: any) => {
  const {
    selectField = 'selected',
    expandField = '',
    dataItemKey = '',
    subItemsField = '',
  } = fields;
  const { expanded = [], dropDownValue = null, filter = null } = state;
  const filtering = Boolean(filter && filter.value);

  return mapTree(
    filtering ? filterBy(data, [filter], subItemsField) : data,
    subItemsField,
    (item) => {
      const props = {
        [expandField]: expanded.includes(item[dataItemKey]),
        [selectField]: dropDownValue && item[dataItemKey] === dropDownValue[dataItemKey],
      };
      return filtering ? extendDataItem(item, subItemsField, props) : { ...item, ...props };
    }
  );
};

export const expandedState = (
  item: any,
  dataItemKey: string,
  expanded: (number | string)[]
) => {
  const nextExpanded = expanded.slice();
  const itemKey = item?.[dataItemKey];
  const index = expanded.indexOf(itemKey);
  index === -1 ? nextExpanded.push(itemKey) : nextExpanded.splice(index, 1);

  return nextExpanded;
};
